import { Subscription } from '../../../../interfaces'

export const getIsPurchased = (subscription: Subscription, now: number) =>
  subscription.user_subscription !== null &&
  subscription.user_subscription.expires_at > now
